<template>
    <div class="d-flex flex-column position-relative">

        <invoice-modal v-if="showInvoiceModal" @toggleInvoiceModal="toggleInvoiceModal" @invoiceCancelled="invoiceCancelled"></invoice-modal>

        <navigator></navigator>
        <div class="col-sm-12 flexGrow1 overflow-auto">

            <filters></filters>

            <invoice-list @selectInvoice="invoiceSelected"></invoice-list>

        </div>



    </div>
</template>

<script>
import Navigator from './Navigator'
import Filters from './Filters'

import InvoiceModal from '@/tools/Invoice//InvoiceModal'

import { mapGetters, mapActions } from 'vuex'

import InvoiceList from './InvoiceList'

export default {
    data: function () {
        return {
            filters: null,
            showInvoiceModal: false,
        }
    },
    created: function () {
    },
    computed: {
        ...mapGetters([
            'getInvoicePageData',
            'getInvoiceList'
        ])
    },
    methods: {
        ...mapActions([
            'setSelectedInvoice',
            'downloadInvoiceList'
        ]),
        invoiceSelected: function (selectedInvoice) {
            console.log(selectedInvoice);
            this.setSelectedInvoice(selectedInvoice)
            this.toggleInvoiceModal()
        },
        invoiceCancelled: function() {
            this.downloadInvoiceList()
        },
        toggleInvoiceModal: function () {
            this.showInvoiceModal = !this.showInvoiceModal
        }
    },
    components:{
        Navigator,
        Filters,
        InvoiceList,
        InvoiceModal
    }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Invoices.vue?0552cbed